import { css } from "@compiled/react";
import { defineMessages } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import AccountCreation, { Social } from "@/components/signup/account-creation";
import { wacToken } from "@/libraries/design/foundations";
import { TypographyStyles, Row } from "@/libraries/wpl/foundations/src";

const messages = defineMessages({
    heading: {
        id: "wacJiraServiceManagementPage.hero-heading-gwp-6480",
        defaultMessage: "Unlock high-velocity service management"
    },
    subheading: {
        id: "wacJiraServiceManagementPage.hero-subheading-gwp-6480",
        defaultMessage:
            "End bad service management for good. Unite teams on a single AI-powered platform to deliver service at scale."
    }
});

const wrapperStyles = css({
    background: wacToken("color.extended.blue100"),
    width: "100%",
    paddingBlockStart: 40,
    paddingBlockEnd: 115,
    clipPath: "polygon(0 0%,100% 0%,100% 88%,0 100%)",
    marginBlockEnd: token("space.400", "32px")
});

const leftStyles = css({
    [media.above.sm]: {
        textAlign: "left"
    },
    textAlign: "center"
});

const headingStyles = css({
    marginBlockStart: token("space.250", "20px")
});

const accountCreationContainerStyles = css({
    maxWidth: 434,
    margin: "0 auto"
});

/**
 * GWP-6480: Embedded Signup Form on jira service management software landing page hero
 *
 * This component is used to display the embedded signup form on the jira service management landing page hero.
 *
 * @returns {JSX.Element}
 */
const GWP6480JSMEmbeddedSignup = () => {
    return (
        <UFOSegment name="jsm-hero-embedded-signup">
            <TypographyStyles>
                <div
                    id="jsm-hero-embedded-signup"
                    data-testid="jsm-hero-embedded-signup"
                    css={wrapperStyles}
                >
                    <Row layout="6-6">
                        <div css={leftStyles}>
                            <h1 css={headingStyles}>
                                {messages.heading.defaultMessage}
                            </h1>
                            <p className="body-lg">
                                {messages.subheading.defaultMessage}
                            </p>
                        </div>
                        <div>
                            <div css={accountCreationContainerStyles}>
                                <AccountCreation
                                    Login={null}
                                    Social={
                                        <Social
                                            providers={{
                                                google: "Google",
                                                microsoft: "Microsoft"
                                            }}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </Row>
                </div>
            </TypographyStyles>
        </UFOSegment>
    );
};

export default GWP6480JSMEmbeddedSignup;
